<!--
    描述：签证对比左侧项目结构树
    时间：2020-12-03
    Created by yef
-->
<template>
	<div class="w-strucutre-layout"
		 :class="[costFiles?'costfilesHeight':'']">
		<div class="w-strucutre-header">
			<div class="left-text">
				<span>签证结构</span>
			</div>
			<div class="btnGroups">
				<el-select v-model="curLevel"
						   class="ml10 select-width"
						   placeholder="请选择"
						   size="small"
						   @change="onChangeLevel">
					<el-option :value="1"
							   label="展开到一级"></el-option>
					<el-option :value="2"
							   label="展开到二级"></el-option>
				</el-select>
				<el-button size="small"
						   type="primary"
						   class="ml5"
						   v-if="roleBtns.includes('structure-edit')"
						   @click.native="dialogObj.visible = true">新增签证
				</el-button>
			</div>
		</div>

		<div class="w-structure-content">
			<!-- 树形表格 -->
			<div class="h100"
				 ref="tableContent">
				<el-table :data="tableData"
						  ref="structureTree"
						  row-key="id"
						  border
						  stripe
						  v-loading="loading"
						  height="100%"
						  highlight-current-row
						  :expand-row-keys="expandKeys"
						  :row-class-name="rowClassName"
						  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
					<el-table-column type="action"
									 width="55"
									 align="center"
									 v-if="showCheckbox">
						<template slot="header"
								  slot-scope="scope">
							<el-checkbox v-model="checkAll"
										 @change="handleCheckAll"></el-checkbox>
						</template>
						<template slot-scope="scope">
							<el-checkbox @change="handleCheck($event, scope.row)"
										 v-model="scope.row.isChecked"
										 :true-label="1"
										 :false-label="0"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="sname"
									 label="单项工程名称"
									 show-overflow-tooltip
									 min-width="150">
						<template slot-scope="scope">{{ scope.row.levelType === 2 ? '' : scope.row.sname }}</template>
					</el-table-column>
					<el-table-column prop="sname"
									 min-width="180"
									 label="单位工程名称"
									 show-overflow-tooltip>
						<template slot-scope="scope">{{ scope.row.levelType === 2 ? scope.row.sname : '' }}</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 编辑弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   @closed="handleClosed"
				   :close-on-click-modal="false">
			<div class="h100" v-if="dialogObj.visible">
				<el-row class="row-container">
					<el-col :span="5" class="row-title is-required-item">签证阶段</el-col>
					<el-col :span="18">
						<el-select v-model="parseObj.phase" size="small">
							<el-option v-for="(item, index) in projectDict.qzjd" :key="'签证' + index" :value="item.value" :label="item.sname"></el-option>
						</el-select>
					</el-col>
				</el-row>
				<el-row class="row-container">
					<el-col :span="5" class="row-title is-required-item">文件类型</el-col>
					<el-col :span="18">
						<el-radio v-model="parseObj.fileType" :label="1">XML</el-radio>
					</el-col>
				</el-row>
				<el-row class="row-container">
					<el-col :span="5" class="row-title is-required-item">上传文件</el-col>
					<el-col :span="18">
						<my-upload mode="add" ref="myUpload" :multiple="false" :maxNum="1" :acceptType="acceptType"></my-upload>
					</el-col>
				</el-row>
			</div>

			<div slot="footer" class="dialog-footer text-center">
				<el-button @click="dialogObj.visible = false" size="small">取 消</el-button>
				<el-button type="primary" size="small" :loading="btnLoading" @click="doPreview">确 定</el-button>
			</div>
		</el-dialog>

		<!-- xml 解析 -->
		<el-dialog title="xml 导入数据预览"
				   :visible.sync="xmlVisible"
				   width="1100px"
				   :close-on-click-modal="false">
			<xml-preview ref="xmlPreview" fromVisa :tableData="parseObj.param1" :fileName="parseObj.param3" :unitList="DanWeiByProjectList" :phase="parseObj.phase"></xml-preview>

			<div slot="footer" class="dialog-footer text-center">
				<el-button @click="xmlVisible = false" size="small">取 消</el-button>
				<el-button type="primary" size="small" :loading="btnLoading" @click="doConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getVisaStructure, parseVisaXml, visaCostSave } from '@/api/modules/dataProject.js'
import { selectDanWeiByProject } from "@/api/modules/project_costfiles";
import { mapState } from 'vuex'

// components
import myUpload from "components/upload/upload";
import xmlPreview from "@/views/project-management/cost-files/xml-preview"; //XML

export default {
	components: {
		myUpload,
		xmlPreview
	},
	props: {
		costFiles: {
			//造价概算传值
			type: String,
			default: ''
		},
		// 是否显示编辑按钮
		editable: {
			type: Boolean,
			default: true
		},
		// 是否显示 多选框
		showCheckbox: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loading: false,
			curLevel: 2,
			tableData: [],
			staticData: [],
			expandKeys: [],
			tableH: 0,
			dialogObj: {
				title: '新增签证',
				visible: false,
				width: '600px',
				type: 'add'
			},
			parseObj: {
				phase: '',	// 签证阶段
				fileType: 1,	// 1 xml
				param2: '',	// 左侧树结构treeId
				projectId: '',	// 项目id
				param3: '',	// 文件名称
				param1: [],	// 列表数据
				param4: []
			},
			btnLoading: false,
			timer: null,
			checkAll: false,
			// xml
			xmlVisible: false,
			DanWeiByProjectList: [],
			pageLoading: null,
		}
	},
	created() {
		if (this.curProjectId) {
			this.getTreeData()

			this.DanWeiByProject()
		}

		this.$nextTick(() => {
			this.tableH = this.$refs.tableContent.offsetHeight
		})
	},
	methods: {
		// 获取结构树 数据
		getTreeData() {
			this.tableData = []
			getVisaStructure({ id: this.curProjectId })
				.then(res => {
					if (res.code === 0) {
                        let _node = this.$utils.findTree([res.data], x => x.levelType === 1)
                        if (!_node) {
                            this.$message.warning('请先完善项目结构！')
                        }
						// 改造数据
						res.data.pid = '0'
						if (res.data.children && res.data.children.length > 0) {
							res.data.children.forEach(x => {
								x.pid = res.data.id
								x.isChecked = 0
							})
						}

						// 默认选择第一个
						if (
							this.showCheckbox &&
							res.data.children[0]
						) {
							res.data.children[0].isChecked = 1
						}

						this.tableData.push(res.data)
						this.staticData = this.tableData
						this.handleCheck(
							true,
							this.tableData[0].children[0]
						);
						// 设置高亮
						if (this.$refs.structureTree) {
							this.onChangeLevel(2);
							this.$refs.structureTree.setCurrentRow(res.data)
						}
					}
				})
				.catch(err => {})
		},

		//造价文件-选择xml文件点击确定跳转页面中单位工程的下拉列表接口
        DanWeiByProject() {
            selectDanWeiByProject({ id: this.curProjectId, isSpe: 1 }).then((res) => {
                if (res.code === 0) {
                    this.DanWeiByProjectList = res.data;
                }
            });
        },

		// 行样式
		rowClassName({ row, rowIndex }) {
			if (row.levelType === 1) {
				return 'single-row'
			} else if (row.levelType === 2) {
				return 'unit-row'
			}
			return ''
		},

		// 点击全选
		handleCheckAll(val) {
			// val 全选 否则 全不选
			this.$utils.eachTree(this.tableData, x => x.isChecked = val ? 1 : 0)

			this.shakeDelay()
		},

		// 多选事件
		handleCheck(val, row) {
			let _parent = this.$utils.findTree(this.tableData, x => x.id === row.pid)?.item || null

			// 关联父级
			if (_parent && _parent.children) {
				let _check = _parent.children.find(x => x.isChecked === 0)
				_parent.isChecked = _check ? 0 : 1
			}

			// 关联子级
			if (row.children && row.children.length > 0) {
				this.$utils.eachTree([row], x => x.isChecked = val)
			}

			// 全部待选中
			let allList = this.$utils.filterTree(
				this.tableData,
				x => x.levelType === 2
			)

			// 当前已选中
			let curList = this.$utils.filterTree(
				this.tableData,
				x => x.isChecked === 1 && x.levelType === 2
			)

			// 设置全选
			if (curList.length === allList.length) {
				this.checkAll = true
				this.tableData[0].isChecked = 1
			}

			// 取消全选
			if (this.checkAll && !val) {
				this.checkAll = false
				this.tableData[0].isChecked = 0
			}
			// 函数调用
			this.shakeDelay()
		},

		// 点击切换展开层级
		onChangeLevel(val) {
			this.loading = true;
			// 先清空
			this.tableData = [];
			this.expandKeys = [];
			// 设置 level
			let _data = JSON.parse(JSON.stringify(this.staticData))
			this.expandLevel(_data, val, this.expandKeys)
			// 展示表格
			setTimeout(() => {
				this.loading = false
				this.tableData = this.staticData
				this.$refs.structureTree ? this.$refs.structureTree.doLayout() : ''
			}, 500)
		},

		// 默认key 值展开
		expandLevel(arr, level, backArr) {
			if (arr.length > 0) {
				arr.forEach(x => {
					if (x.children && x.levelType < level) {
						backArr.push(x.id)
						this.expandLevel(x.children, level, backArr)
					}
				})
			}
		},

		// 防抖事件
		shakeDelay() {
			// 如果此时定时器在， 清除
			if (this.timer) {
				clearTimeout(this.timer)
			}
			let list = this.$utils.filterTree(
				this.tableData,
				x => x.isChecked === 1 && x.levelType === 2
			)
			let arr = list.map(x => x.id)
			// 没继续点击后 做操作处理
			this.timer = setTimeout(() => {
				this.$emit('onCheck', arr)
			}, 1200)
		},

		// handleClosed
		handleClosed() {
			this.parseObj.phase = ''
		},

		// 点击确定 解析xml 文件
		doPreview() {
			if (this.parseObj.phase === '') {
            	this.$message.warning('请选择签证阶段!');
            	return
            }

            let _addList = this.$refs.myUpload.addList;
            if (_addList.length === 0) {
                this.$message.warning("请上传具体的文件!");
                return;
            }

            this.btnLoading = true;

			let formData = new FormData();
            for (let item of _addList) {
                formData.append("file", item);
            }
			parseVisaXml(formData)
				.then(res => {
					this.btnLoading = false;
					this.xmlVisible = true
					// 表格数据
					this.parseObj.param1 = res.data.param1
					// 文件名称
					this.parseObj.param3 = res.data.param3
					// 无用字段
					this.parseObj.param4 = res.data.param4
				})
				.catch(err => {
					this.btnLoading = false;
				})
		},

		// 确定导入
		doConfirm() {
			let list = []
			this.$refs.xmlPreview.leftData.forEach((x) => {
                if (x.danWeiId) {
                    list.push(x.danWeiId);
                }
            });
			let params = this.$utils.clone(this.parseObj, true)
			params.projectId = this.curProjectId
			params.param1 = this.$refs.xmlPreview.leftData
			params.param2 = list.length > 0 ? list.join(',') : ''
			params.isSpe = 1

			// loading
            this.pageLoading = this.$loading({
                lock: true,
                text: "正在导入中...",
                spinner: "el-icon-loading",
            });

			visaCostSave(params)
				.then(res => {
					// loading
                    this.pageLoading.close();
                    this.btnLoading = false

                    this.$message.success("保存成功！");
                    // 关闭弹窗
                    this.dialogObj.visible = false
                    this.xmlVisible = false
                    // 重新加载数据
                    setTimeout(() => {
                    	this.getTreeData()
                    }, 1000)
				})
				.catch(err => {
					// loading
                    this.pageLoading.close();
                    this.btnLoading = false
				})
		},

		// 确定回调
		onSuccess() {
			// 关闭弹窗
			this.dialogObj.visible = false
		},

		// 关闭弹窗的事件
		handleClose() {
			this.dialogObj.visible = false;
			this.dialogObj.type = 'add';
			this.btnLoading = false;
			// 刷新结构树
			this.getTreeData()
		}
	},
	computed: {
		...mapState('app', {
			clientSize: state => state.clientSize
		}),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		}),
		...mapState('dict', {
			projectDict: state => state.projectDict
		}),
		// 当前的 项目Id
		curProjectId() {
			return this.$route.query.projectId
		},

		// 文件上传 文件类型
        acceptType() {
            return ["xml", "XML"];
        },
	},

	watch: {
		// 页面大小变化
		clientSize(obj) {
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		},
		// 监听项目ID 的变化
		curProjectId() {
			setTimeout(() => {
				this.getTreeData()
			}, 300)
			this.$nextTick(() => {
				this.tableH = this.$refs.tableContent.offsetHeight
			})
		}
	}
};
</script>

<style scoped lang="less">
/deep/ .el-table__body tr.current-row td {
	background-color: #dcbf5f !important;
}

.select-width {
	width: 150px;
}

.row-container {
	line-height: 40px;

	.row-title {
		padding: 0 15px;
		text-align: right;
		justify-content: flex-end;
	}
}
</style>
